<template>
  <md-field
    :md-clearable="clearable"
    class="select"
    :class="{ &quot;md-invalid&quot;: errors.length }"
  >
    <label v-if="label">
      {{ label }}
    </label>
    <md-select
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      v-bind="selectInputProps"
      @md-opened="onShowOptions"
      @input="onChange"
    >
      <md-option
        v-for="option in options"
        :key="option[valueKey]"
        :value="option[valueKey]"
      >
        {{ option[labelKey] }}
      </md-option>
      <slot />
    </md-select>
    <span
      v-for="(error, index) in errors"
      :key="index"
      class="md-error"
    >
      {{ $t(`errors.${error}`) }}
    </span>
  </md-field>
</template>

<script>
  export default {
    name: 'XInput',
    model: {
      prop: 'value',
      event: 'update'
    },
    props: {
      inputProps: {
        type: Object,
        default: () => ({})
      },
      value: {
        type: [String, Number]
      },
      label: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      errors: {
        type: Array,
        default: () => []
      },
      options: {
        type: Array,
        default: () => []
      },
      valueKey: {
        type: String,
        default: 'id'
      },
      labelKey: {
        type: String,
        default: 'name'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      autoSize: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      autoSizeStyles () {
        const maxOptionsLabelLength =  (this.options ?? []).reduce((max, option) => {
          return option[this.labelKey].length > max ? option[this.labelKey].length : max
        }, 0)
        return {
          width: `${maxOptionsLabelLength * 9}px`
        }
      },
      selectInputProps () {
        return {
          ...this.inputProps,
          ...(this.autoSize ? { style: { minWidth: this.autoSizeStyles.width } } : {})
        }
      }
    },
    methods: {
      onChange (value) {
        this.$emit('update', value)
      },
      onShowOptions () {
        if (!this.autoSize) return;
        const selectOptions = document.querySelector('.md-select-menu')
        if (selectOptions) {
          selectOptions.style.minWidth = this.autoSizeStyles.width
        }
      }
    }
  }
</script>
<style lang='scss' scoped rel='stylesheet/scss'>
.select {
  /deep/ .md-clear {
    margin-right: 24px;

    svg {
      background: inherit;
    }
  }

  /deep/ .md-theme-default {
    background: inherit;
  }
}
</style>

